import React, {FC, useState} from 'react'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import {InputDialog, SectionNotification, Text, TextButton} from 'wix-ui-tpa/cssVars'

import {CardIcon} from '../../../../components-shared/Icons/CardIcon'
import {EXPERIMENTS} from '../../../../utils/constants'

import {paymentTokenizationDataHooks} from './constants'
import {classes} from './PaymentTokenization.st.css'

interface PaymentTokenizationProps {
  guestPolicy?: string | null
}

export const PaymentTokenization: FC<PaymentTokenizationProps> = ({guestPolicy}) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const [isPolicyOpen, setIsPolicyOpen] = useState(false)
  const showPaymentPolicy =
    experiments.enabled(EXPERIMENTS.tableReservationsCancellationFee) && Boolean(guestPolicy)
  const paymentPolicyTitle = t('uou-reservations.reservation-details.card-guarantee.payment-policy')
  const closeDialog = () => setIsPolicyOpen(false)

  return (
    <>
      <SectionNotification type="alert" className={classes.paymentTokenization}>
        <SectionNotification.Icon
          icon={<CardIcon className={classes.paymentTokenizationImage} />}
        />
        <SectionNotification.Text>
          <div className={classes.body}>
            <Text tagName="p" className={classes.text}>
              {t('uou-reservations.reservation-details.payment-tokenization')}
            </Text>
            {showPaymentPolicy ? (
              <TextButton
                className={classes.link}
                onClick={() => setIsPolicyOpen(true)}
                data-hook={paymentTokenizationDataHooks.paymentPolicyLink()}
              >
                {paymentPolicyTitle}
              </TextButton>
            ) : null}
          </div>
        </SectionNotification.Text>
      </SectionNotification>
      {showPaymentPolicy ? (
        <InputDialog
          isOpen={isPolicyOpen}
          onClose={closeDialog}
          title={paymentPolicyTitle}
          closeButtonAriaLabel={t('uou-reservations.shared.modal-close-button')}
          primaryButton={{
            text: t('uou-reservations.reservation-details.terms-privacy.close'),
            onClick: closeDialog,
          }}
          forceBWTheme
          className={classes.policyDialog}
        >
          <Text tagName="p" className={classes.dialogContent}>
            {guestPolicy}
          </Text>
        </InputDialog>
      ) : null}
    </>
  )
}
